export type UpcomingPhase = 'PHASE_1' | 'PHASE_2' | 'PHASE_3' | 'PHASE_4';

export interface IUpcomingFeature {
  id: string;
  title: string;
  description: string;
  phase: UpcomingPhase;
  displayOrder: number;
  archived: boolean;
  archivedAt: string | null;
  createdAt: string;
  createdBy: string | null;
  updatedAt: string;
  updatedBy: string | null;
}

export interface IUpcomingFeatureCreate {
  title: string;
  description: string;
  phase: UpcomingPhase;
  /** When omitted at create, the server assigns max(existing display_order) + 10. */
  displayOrder?: number;
}

/** Update always sets displayOrder explicitly — there is no implicit re-ordering. */
export interface IUpcomingFeatureUpdate {
  title: string;
  description: string;
  phase: UpcomingPhase;
  displayOrder: number;
}

export function formatPhaseLabel(phase: UpcomingPhase): string {
  return phase.replace('_', ' ');
}
